function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContactDetails = function ContactDetails($attrs) {
    var _this = this;

    _classCallCheck(this, ContactDetails);

    var setSubtype = function setSubtype(contactModel) {
        _this.subtype = (contactModel.subtype || {}).value;
    };

    this.$onInit = function () {
        if (_this.contactModel) setSubtype(_this.contactModel);
    };

    this.$onChanges = function (_ref) {
        var _ref$contactModel = _ref.contactModel,
            currentValue = _ref$contactModel.currentValue,
            previousValue = _ref$contactModel.previousValue;

        if (currentValue && currentValue !== previousValue) setSubtype(currentValue);
    };
    this.args = { contactModel: $attrs.contactModel };
};

ContactDetails.$inject = ['$attrs'];

export default ContactDetails;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/ContactDetails/ContactDetailsCtrl.js
// module id = 1618
// module chunks = 0